const getFormattedCredentials = (credential) => {
  if (typeof credential !== 'string') return "";

  switch (credential) {
    case "NonHCP":
      return "non-hcp";
    case "OLHCP":
      return "other_licensed_hcp";
    case "RNBC":
      return "rn_bc";
    case "RNC":
      return "rn_c";
    default:
      return credential.toLowerCase();          
  }
}

const getFormattedSpeciality = (speciality) => {
  if (typeof speciality !== 'string') return "";

  switch (speciality) {
    case "Anesthesiologist":
      return "anesthesiologist";
    case "BariatricSurgery":
      return "bariatric_surgery";
    case "BreastSurgery":
      return "breast_surgery";
    case "CardiacSurgery":
      return "cardiac_surgery";
    case "ColorectalSurgery":
      return "colorectal_surgery";
    case "ENT":
      return "ent";
    case "GeneralSurgery":
      return "general_surgery";
    case "ObstetricsSurgery":
      return "obstetrics_gynecologicsurgery_urogynecologist";
    case "Nursing":
      return "nursing";
    case "OralSurgery":
      return "oral_surgery";
    case "OrthopedicSurgery":
      return "orthopedic_surgery";
    case "PainManagement":
      return "pain_management";
    case "PlasticSurgery":
      return "plastic_surgery";
    case "SpineNeurosurgery":
      return "spine_neurosurgery";
    case "ThoracicSurgery":
      return "thoracic_surgery";
    case "UrologyNephrology":
      return "urology_nephrology";
    case "Other":
      return "other";
    default:
      return speciality.toLowerCase();
  }
}

export { getFormattedCredentials, getFormattedSpeciality };